export default function apiKey() {
  if (import.meta.env.REACT_APP_DEPLOY_ENV === 'production') {
    return import.meta.env.REACT_APP_POCAPAN_PRODUCTION_API_KEY;
  }
  if (import.meta.env.REACT_APP_DEPLOY_ENV === 'development') {
    return import.meta.env.REACT_APP_POCAPAN_DEVELOPMENT_API_KEY;
  }
  return import.meta.env.REACT_APP_POCAPAN_LOCAL_API_KEY;
}
